module.exports = __webpack_public_path__ + "media/images/common/about/bg-5-7c86f8cee5f8c1a663696a510bc30577.jpg";